import React from "react";
import { View } from "react-native";
import SnackBar from "react-native-snackbar-component";
import { useSelector } from "react-redux";

const SnackBarComponent = () => {
  const {
    shouldShow = false,
    message = "Error",
    position = "bottom",
    bottom = 45,
    autoHide = true,
    actionText = "",
    actionHandler = (e) => {},
  } = useSelector(({ snackbar }) => snackbar);
  const autoHidingTime = autoHide ? 3000 : 0;

  return (
    <View>
      <SnackBar
        visible={shouldShow}
        textMessage={message}
        position={position}
        bottom={bottom}
        actionHandler={actionHandler}
        actionText={actionText}
        autoHidingTime={autoHidingTime}
      />
    </View>
  );
};

export default SnackBarComponent;
